export default function () {
  // reativando com do usuario e mostrando modal de bem vindo
  this.doActive()
}



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/resources/mounted.js